export interface NormalizedMetricDateRange {
  startDate: Date;
  endDate: Date;
}

/**
 * Preserve the user's selected calendar day and convert it to a UTC date-only value.
 * This avoids timezone shifts when dates come from local date pickers.
 *
 * Example (Europe/Berlin):
 * Local 2025-02-01 -> UTC 2025-02-01T00:00:00.000Z
 */
const toUtcDateOnly = (date: Date): Date =>
  new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));

export const normalizeStartOfDay = (date: Date): Date => {
  const d = toUtcDateOnly(date);
  d.setUTCHours(0, 0, 0, 0);

  return d;
};

export const normalizeEndOfDay = (date: Date): Date => {
  const d = toUtcDateOnly(date);
  d.setUTCHours(23, 59, 59, 999);

  return d;
};

export const normalizeMetricDateRange = (
  startDate: Date,
  endDate: Date,
): NormalizedMetricDateRange => ({
  startDate: normalizeStartOfDay(startDate),
  endDate: normalizeEndOfDay(endDate),
});
